import axiosClient from './axiosClient'
const jobpositionApi = {
  getAll: (params) => {
    const url = '/group-location/getAll'
    return axiosClient.get(url, { params })
  },
}
export default jobpositionApi
